import { render, staticRenderFns } from "./UserRightsAttach.vue?vue&type=template&id=e7675960"
import script from "./UserRightsAttach.js?vue&type=script&lang=js&external"
export * from "./UserRightsAttach.js?vue&type=script&lang=js&external"
import style0 from "./UserRightsAttach.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports